type Props = {
  percent: number;
};

const colorMap = {
  default: '#519EFB',
  green: '#00C950',
  red: '#DE191D',
} as const;

const indicatorOuter = {
  blue: 'border-blue-400 shadow-blue',
  green: 'border-green-450 shadow-green',
  red: 'border-red-450 shadow-red',
} as const;

const indicatorInner = {
  blue: 'bg-blue-450',
  green: 'bg-green-350',
  red: 'bg-red-350',
} as const;

export const ProgressBar = ({ percent }: Props) => {
  const isOver100 = percent > 100;
  const isAtLeast100 = percent >= 100;
  const isExactly100 = percent === 100;

  const mainWidth = Math.min(100, percent);
  const mainColor = isAtLeast100 ? colorMap.green : colorMap.default;

  const redWidth = isOver100 ? ((percent - 100) / percent) * 100 : 0;
  const redStart = isOver100 ? (100 / percent) * 100 : 0;

  const indicatorPosition = isOver100 ? redWidth : percent;

  const showIndicator = !isAtLeast100 || isExactly100 || isOver100;
  const indicatorColor = isOver100 ? 'red' : isExactly100 ? 'green' : 'blue';

  return (
    <div className="relative w-full h-[10px]">
      <div className="absolute inset-0 bg-dark-100 rounded-full overflow-hidden">
        {mainWidth > 0 && (
          <div
            className="absolute left-0 h-full rounded-full"
            style={{ width: `${mainWidth}%`, backgroundColor: mainColor }}
          />
        )}
        {redWidth > 0 && (
          <div
            className="absolute h-full rounded-full"
            style={{
              right: `${redStart}%`,
              width: `${redWidth}%`,
              backgroundColor: colorMap.red,
            }}
          />
        )}
      </div>
      {showIndicator && (
        <div
          className={`
            absolute top-1/2 -translate-y-1/2 w-4 h-4 rounded-full border-4 z-30
            ${indicatorOuter[indicatorColor]}
          `}
          style={{ left: `calc(${indicatorPosition}% - 8px)` }}
        >
          <div
            className={`
              absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
              w-2 h-2 rounded-full
              ${indicatorInner[indicatorColor]}
            `}
          />
        </div>
      )}
    </div>
  );
};
